import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2"; // Import SweetAlert2
import { Link } from "react-router-dom"; 

const EditListingNavbar = () => {
  const { listing_id } = useParams(); // Get listing_id from URL parameters
  const [sellerId, setSellerId] = useState(null); // State to store the seller ID
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSellerId = async () => {
      try { 
        const response = await axios.get(`${baseurl}getSellerIdByListing/${listing_id}`);
        if (response.data.message === "Seller ID fetched successfully") {
          setSellerId(response.data.data); // Store the fetched seller ID
        } else {
          console.log("Failed to fetch Seller ID");
        }
      } catch (error) {
        console.error("Error fetching seller ID:", error);
      }
    };

    fetchSellerId();
  }, [listing_id]); // Run once when component mounts or when listing_id changes

  return (
    <>
      <div className="text-start mb-3">
        <Link to={`/seller/edit-listing/${listing_id}`} className="nacs me-2">Basic Details</Link>
        
        {sellerId && (
          <Link to={`/seller/listing-images/${listing_id}/${sellerId}`} className="nacs me-2">
            Product Images
          </Link>
        )}
        
        <Link to={`/seller/listing-two/${listing_id}`} className="nacs me-2">Specification</Link>
        <Link to={`/seller/listing-categlog/${listing_id}/${sellerId}`} className="nacs me-2">Categlogs</Link>
        <Link to={`/seller/policy-charges/${listing_id}`} className="nacs me-2">Policy & Charges</Link>
      </div>
    </>
  );
};

export default EditListingNavbar;
